(ns ui.view.survey.modals.confirm-overwrite-answers
  (:require
   [common.localization :as loc]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.components.input.checkbox :as checkbox]
   [ui.components.modal.view :as modal]
   [ui.view.survey.event :as survey-view-event]
   [ui.view.survey.modals.sub :as sub]
   [ui.view.survey.sub :as survey-view-sub]))

(defn confirm-overwrite-body
  [{:keys [survey-id _lang confirmed? parsing-error?]}]
  [:div
   {:class "flex flex-col gap-6"}
   (when-not parsing-error?
     [:p
      (loc/tr :survey-import-confirm-no-errors)])
   [:div
    {:class "flex flex-row gap-4"}
    [:label
     {:class "text-[14px] text-warning-light-text-accent font-semibold flex flex-row gap-2"}
     [checkbox/view
      {:value     confirmed?
       :on-change (fn [checked?]
                    (rf/dispatch [::survey-view-event/confirm-import-data survey-id checked?]))}]
     (loc/tr :survey-import-confirm)]]])

(defn confirm-overwrite-footer
  [{:keys [survey-id lang confirmed? parsed-data parsing-error?]}]
  [:div
   {:class "flex flex-row flex-auto"}
   [:div
    {:class "flex flex-row justify-content-start"}
    [button/secondary-hollow
     {:on-click (fn [_]
                  (rf/dispatch [::survey-view-event/close-overwrite-warning-modal survey-id parsing-error?]))}
     (loc/tr :cancel nil lang)]]
   [:div
    {:class "flex flex-row flex-auto content-stretch justify-content-end"}
    [button/primary-solid
     {:on-click  (fn [_]
                   (rf/dispatch [::survey-view-event/submit-confirm-overwrite survey-id parsed-data]))
      :disabled? (not confirmed?)}
     (loc/tr :submit-survey-button nil lang)]]])

(defn view
  []
  (let [survey-id @(rf/subscribe [::sub/survey-id])
        lang @(rf/subscribe [::survey-view-sub/selected-lang survey-id])
        confirmed? @(rf/subscribe [::survey-view-sub/import-data-confirmed? survey-id])
        unconfirmed-parsed-data @(rf/subscribe [::survey-view-sub/unconfirmed-parsed-data-by-survey survey-id])
        parsing-error? @(rf/subscribe [::survey-view-sub/parsing-error? survey-id])]
    [modal/view
     {:visible? @(rf/subscribe [::survey-view-sub/overwrite-answers-modal-open? survey-id])
      :hide!    #(rf/dispatch [::survey-view-event/close-overwrite-warning-modal survey-id parsing-error?])
      :size     :full}
     (loc/tr :survey-import-confirm-modal-title)
     [confirm-overwrite-body {:survey-id      survey-id
                              :lang           lang
                              :confirmed?     confirmed?
                              :parsing-error? parsing-error?}]
     [confirm-overwrite-footer {:survey-id      survey-id
                                :lang           lang
                                :confirmed?     confirmed?
                                :parsed-data    unconfirmed-parsed-data
                                :parsing-error? parsing-error?}]]))
